import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Form from '../multi-step-form';
import { useState } from 'react';
import Modal from '../../elements/modal';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var Calculator = function Calculator(_ref) {
  var calculator = _ref.calculator,
      submit = _ref.submit,
      modalContent = _ref.modalContent;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalOpen = _useState2[0],
      setModalOpen = _useState2[1];

  var toggleModal = function toggleModal() {
    return setModalOpen(!modalOpen);
  };

  var handleKeypress = function handleKeypress(_ref2) {
    var key = _ref2.key;
    return key === 'Enter' && toggleModal();
  };

  var calculatorSubmit = function calculatorSubmit(data) {
    var updateTerm = function updateTerm(data) {
      return data.term && (data.term = data.term * 12);
    };

    updateTerm(data);
    var calculatorData = {
      type: 'calculator',
      inputs: _objectSpread({}, data)
    };
    submit(calculatorData);
  };

  return _jsx("div", {
    sx: {
      marginY: 0,
      padding: 'md',
      paddingTop: [24, 64],
      backgroundColor: 'grey-05',
      borderRadius: 3,
      variant: 'elements.calculator.container'
    },
    children: _jsxs("div", {
      sx: {
        variant: 'elements.calculator.wrapper'
      },
      children: [_jsx("div", {
        sx: {
          variant: 'elements.calculator.label'
        },
        children: calculator.label
      }), _jsx(Form, {
        formType: "calculator",
        schema: calculator,
        submit: calculatorSubmit
      }), modalContent ? _jsxs("div", {
        sx: {
          variant: 'elements.calculator.modal.label'
        },
        onClick: toggleModal,
        onKeyPress: handleKeypress,
        role: "link",
        tabIndex: 0,
        children: ["How it works", _jsx(Modal, {
          close: toggleModal,
          isOpen: modalOpen,
          type: "calculator",
          children: _jsx("div", {
            sx: {
              flexDirection: ['column', 'row'],
              variant: 'elements.calculator.modal.content'
            },
            children: modalContent
          })
        })]
      }) : null]
    })
  });
};

export default Calculator;
//# sourceMappingURL=calculator.js.map